import type { ReactElement } from 'react';
import cx from 'clsx';
import { CheckmarkOutlinedCheckboxIcon } from './icons/checkmark-outlined-checkbox';
import { MinusOutlinedCheckboxIcon } from './icons/minus-outlined-checkbox';
import styles from './checkbox.module.css';

interface CheckboxIndicatorProps {
  className?: string;
  isSelected?: boolean;
  isIndeterminate?: boolean;
}

/**
 * Non-interactive checkbox visual, styled identically to `Checkbox`. Use for surfaces
 * that already manage selection semantics themselves (e.g. a `role="option"` item)
 * and must not nest a real, focusable `Checkbox`.
 */
export function CheckboxIndicator({
  className,
  isSelected,
  isIndeterminate,
}: CheckboxIndicatorProps): ReactElement {
  let icon = null;
  if (isSelected) {
    icon = <CheckmarkOutlinedCheckboxIcon />;
  }

  if (isIndeterminate) {
    icon = <MinusOutlinedCheckboxIcon />;
  }

  return (
    <div
      className={cx(className, styles['checkbox-wrapper'])}
      data-indeterminate={isIndeterminate || undefined}
      data-selected={isSelected || undefined}
    >
      <div className={styles.checkbox} data-checkbox>
        {icon}
      </div>
    </div>
  );
}
